export default __webpack_public_path__ + "static/media/dashboard-light.fa3377fa.svg";